import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';

import { HIDE_APPOINTMENT_INFO } from 'modules/queues/common/actions/appointmentInfo';
import { CHANGE_PATIENT_INFO_TAB } from '../actions/changePatientInfoTab';

const defaultState = {
  tabId: '1',
};

export default createReducer(defaultState, {
  [CHANGE_PATIENT_INFO_TAB]: (state, { meta: { tabId } }) => ({
    ...state,
    tabId,
  }),

  [HIDE_APPOINTMENT_INFO]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
